export default "__VITE_ASSET___lRiYlKB__"